import L from 'leaflet';
import bearing from '@turf/bearing';
import { visualizeSearchPattern, clearSearchPatterns, addPspOverGroundToMap, addPspOverSurfaceToMap, addDatumToMap } from '../map/searchPatterns';
import { deleteFromLocalStorage, listLocalStorageItems, saveToLocalStorage, StoredItem } from '../util/localStorage';

// --- Data from bsd-data.js ---
const bsdData = {
    uncorrectedSweepWidths: {
        person: { low: { 1: 0.2, 3: 0.2, 5: 0.3, 10: 0.3, 15: 0.3, 20: 0.3 }, high: { 1: 0.3, 3: 0.4, 5: 0.5, 10: 0.5, 15: 0.5, 20: 0.5 } },
        raft1: { low: { 1: 0.7, 3: 1.3, 5: 1.7, 10: 2.3, 15: 2.6, 20: 2.7 }, high: { 1: 0.9, 3: 1.8, 5: 2.3, 10: 3.1, 15: 3.4, 20: 3.7 } },
        raft4: { low: { 1: 0.7, 3: 1.7, 5: 2.2, 10: 3.1, 15: 3.5, 20: 3.9 }, high: { 1: 1.0, 3: 2.2, 5: 3.0, 10: 4.0, 15: 4.6, 20: 5.0 } },
        raft6: { low: { 1: 0.8, 3: 1.9, 5: 2.6, 10: 3.6, 15: 4.3, 20: 4.7 }, high: { 1: 1.1, 3: 2.5, 5: 3.4, 10: 4.7, 15: 5.5, 20: 6.0 } },
        raft8: { low: { 1: 0.8, 3: 2.0, 5: 2.7, 10: 3.8, 15: 4.4, 20: 4.9 }, high: { 1: 1.1, 3: 2.5, 5: 3.5, 10: 4.8, 15: 5.7, 20: 6.2 } },
        raft10: { low: { 1: 0.8, 3: 2.0, 5: 2.8, 10: 4.0, 15: 4.8, 20: 5.3 }, high: { 1: 1.1, 3: 2.6, 5: 3.6, 10: 5.1, 15: 6.1, 20: 6.7 } },
        raft15: { low: { 1: 0.9, 3: 2.2, 5: 3.0, 10: 4.3, 15: 5.1, 20: 5.7 }, high: { 1: 1.1, 3: 2.8, 5: 3.8, 10: 5.5, 15: 6.5, 20: 7.2 } },
        raft20: { low: { 1: 0.9, 3: 2.3, 5: 3.3, 10: 4.9, 15: 5.8, 20: 6.5 }, high: { 1: 1.2, 3: 3.0, 5: 4.1, 10: 6.1, 15: 7.3, 20: 8.1 } },
        raft25: { low: { 1: 0.9, 3: 2.4, 5: 3.5, 10: 5.2, 15: 6.3, 20: 7.0 }, high: { 1: 1.2, 3: 3.1, 5: 4.3, 10: 6.4, 15: 7.8, 20: 8.7 } },
        powerboat0: { low: { 1: 0.4, 3: 0.8, 5: 1.1, 10: 1.5, 15: 1.6, 20: 1.8 }, high: { 1: 0.5, 3: 1.1, 5: 1.4, 10: 1.9, 15: 2.1, 20: 2.3 } },
        powerboat6: { low: { 1: 0.8, 3: 1.5, 5: 2.2, 10: 3.3, 15: 4.0, 20: 4.5 }, high: { 1: 1.0, 3: 2.0, 5: 2.9, 10: 4.3, 15: 5.2, 20: 5.8 } },
        powerboat10: { low: { 1: 0.8, 3: 1.9, 5: 2.9, 10: 4.7, 15: 5.9, 20: 6.8 }, high: { 1: 1.1, 3: 2.5, 5: 3.8, 10: 6.1, 15: 7.7, 20: 8.8 } },
        powerboat16: { low: { 1: 0.9, 3: 2.4, 5: 3.9, 10: 7.0, 15: 9.3, 20: 11.1 }, high: { 1: 1.2, 3: 3.1, 5: 5.1, 10: 9.1, 15: 12.1, 20: 14.4 } },
        powerboat24: { low: { 1: 0.9, 3: 2.5, 5: 4.3, 10: 8.3, 15: 11.4, 20: 14.0 }, high: { 1: 1.2, 3: 3.2, 5: 5.6, 10: 10.7, 15: 14.7, 20: 18.1 } },
        sailboat4: { low: { 1: 0.8, 3: 1.5, 5: 2.1, 10: 3.0, 15: 3.6, 20: 4.0 }, high: { 1: 1.0, 3: 1.9, 5: 2.7, 10: 3.9, 15: 4.7, 20: 5.2 } },
        sailboat6: { low: { 1: 0.8, 3: 1.7, 5: 2.5, 10: 3.7, 15: 4.6, 20: 5.1 }, high: { 1: 1.0, 3: 2.2, 5: 3.2, 10: 4.8, 15: 5.9, 20: 6.6 } },
        sailboat7: { low: { 1: 0.9, 3: 1.9, 5: 2.8, 10: 4.4, 15: 5.4, 20: 6.3 }, high: { 1: 1.1, 3: 2.4, 5: 3.6, 10: 5.7, 15: 7.0, 20: 8.1 } },
        sailboat9: { low: { 1: 0.9, 3: 2.1, 5: 3.2, 10: 5.3, 15: 6.6, 20: 7.7 }, high: { 1: 1.1, 3: 2.7, 5: 4.1, 10: 6.8, 15: 8.6, 20: 10.0 } },
        sailboat12: { low: { 1: 0.9, 3: 2.3, 5: 3.8, 10: 6.6, 15: 8.6, 20: 10.3 }, high: { 1: 1.2, 3: 3.0, 5: 4.9, 10: 8.5, 15: 11.2, 20: 13.3 } },
        sailboat15: { low: { 1: 0.9, 3: 2.4, 5: 4.0, 10: 7.3, 15: 9.7, 20: 11.6 }, high: { 1: 1.2, 3: 3.1, 5: 5.2, 10: 9.4, 15: 12.5, 20: 15.0 } },
        sailboat20: { low: { 1: 0.9, 3: 2.5, 5: 4.2, 10: 7.9, 15: 10.7, 20: 13.1 }, high: { 1: 1.2, 3: 3.2, 5: 5.5, 10: 10.2, 15: 13.9, 20: 16.9 } },
        sailboat23: { low: { 1: 0.9, 3: 2.5, 5: 4.4, 10: 8.3, 15: 11.6, 20: 14.2 }, high: { 1: 1.2, 3: 3.3, 5: 5.7, 10: 10.8, 15: 15.0, 20: 18.4 } },
    },
    corrections: {
        target: {
            small: { wind: { 0: 1.0, 15: 0.5, 25: 0.25 } },
            large: { wind: { 0: 1.0, 15: 0.9, 25: 0.9 } }
        }
    }
};

// --- CoordInputComponent from coord-input.js ---
if (!customElements.get('coord-input')) {
    class CoordInputComponent extends HTMLElement {
        static observedAttributes = ['value', 'label'];
        static instances: CoordInputComponent[] = [];
        static isDecimalMode = false;

        shadow: ShadowRoot;
        decimalValue: number;

        constructor() {
            super();
            this.shadow = this.attachShadow({ mode: 'open' });
            this.decimalValue = 0;
            CoordInputComponent.instances.push(this);
        }

        connectedCallback() {
            if (this.hasAttribute('value')) {
                this.decimalValue = parseFloat(this.getAttribute('value')!);
            }
            this.render();
        }

        attributeChangedCallback(name: string, oldValue: string, newValue: string) {
            if (name === 'value' && parseFloat(newValue) !== this.decimalValue) {
                this.decimalValue = parseFloat(newValue);
                this.render();
            }
        }

        static toggleMode() {
            this.isDecimalMode = !this.isDecimalMode;
            this.instances.forEach(inst => inst.render());
        }

        toDegMin(val: number) {
            const deg = Math.trunc(val);
            const min = Math.abs((val - deg) * 60);
            return { deg, min };
        }

        toDecimal(deg: number, min: number) {
            return Math.sign(deg) * (Math.abs(deg) + min / 60);
        }

        getDigits() {
            let str;
            if (CoordInputComponent.isDecimalMode) {
                str = this.decimalValue.toFixed(5);
                if (!str.includes("-")) str = str.padStart(9, '0');
            } else {
                const { deg, min } = this.toDegMin(this.decimalValue);
                const sign = deg < 0 ? '-' : '+';
                const absDeg = Math.abs(deg).toString().padStart(3, '0');
                const minStr = min.toFixed(2).padStart(5, '0');
                str = `${sign}${absDeg}'${minStr}`;
            }
            return str.split('').map((c, idx) => ({
                char: c,
                editable: /[0-9]/.test(c) || (idx === 0 && (c === '+' || c === '-'))
            }));
        }

        changeDigit(index: number, delta: number) {
            const digits = this.getDigits();
            const val = digits[index].char;
            if (!/[0-9]/.test(val)) return;

            let newDigit = (parseInt(val, 10) + delta + 10) % 10;
            if ((!CoordInputComponent.isDecimalMode) && (newDigit > 5) && index > 0 && digits[index - 1].char === '\'') {
                if (delta === 1) newDigit = 0;
                else if (delta === -1) newDigit = 5;
            }
            this.setDigit(index, newDigit.toString());
            this.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        }

        setDigit(index: number, newChar: string) {
            const digits = this.getDigits();
            if (!(/[0-9]/.test(newChar) || (index === 0 && (newChar === '+' || newChar === '-')))) return;

            digits[index].char = newChar;
            this.updateDigitInput(index, newChar);

            const str = digits.map(d => d.char).join('');
            if (CoordInputComponent.isDecimalMode) {
                this.decimalValue = parseFloat(str);
            } else {
                const match = str.match(/^([-+]?)(\d{3})'(\d{2}\.\d{2})$/);
                if (!match) return;
                const sign = match[1] === '-' ? -1 : 1;
                const deg = parseInt(match[2]);
                const min = parseFloat(match[3]);
                if (isNaN(deg) || isNaN(min)) return;
                this.decimalValue = sign * this.toDecimal(deg, min);
            }
            this.setAttribute('value', this.decimalValue.toString());
        }

        updateDigitInput(index: number, newChar: string) {
            const inputs = this.shadow.querySelectorAll('.digit-input');
            if (inputs[index]) {
                (inputs[index] as HTMLInputElement).value = newChar;
            }
        }

        render() {
            const coordInputCss = `
                .coord-wrapper { display: inline-block; margin: 10px; font-family: monospace; text-align: center; }
                .coord-label { display: block; font-weight: bold; margin-bottom: 4px; }
                .coord-grid { display: grid; grid-template-rows: auto auto auto; grid-auto-flow: column; justify-content: center; align-items: center; }
                .digit-btn { cursor: pointer; display: flex; justify-content: center; font-size: 12px; line-height: 1; user-select: none; width: 1.5ch; padding: 4px 0; }
                .digit-input { width: 1.5ch; border: none; text-align: center; font-size: 16px; background: none; padding: 0; margin: 0; color: inherit; }
                .digit-input.separator { color: gray; pointer-events: none; }

                @media (max-width: 600px) {
                    .coord-wrapper { margin: 5px; }
                    .digit-btn {
                        font-size: 16px;
                        padding: 10px 0;
                        min-height: 24px;
                    }
                    .digit-input {
                        font-size: 18px;
                        height: 30px;
                    }
                }
            `;
            const styleElem = document.createElement('style');
            styleElem.textContent = coordInputCss;

            const wrapper = document.createElement('div');
            wrapper.className = 'coord-wrapper';

            const label = this.getAttribute('label');
            if (label) {
                const lbl = document.createElement('span');
                lbl.className = 'coord-label';
                lbl.textContent = label;
                wrapper.appendChild(lbl);

                const grid = document.createElement('div');
                grid.className = 'coord-grid';

                const digits = this.getDigits();
                digits.forEach((d, i) => {
                    const up = document.createElement('div');
                    up.className = 'digit-btn';
                    if (d.editable && d.char >= '0' && d.char <= '9') {
                        up.textContent = '▲';
                        up.onclick = () => this.changeDigit(i, 1);
                    }
                    grid.appendChild(up);

                    const input = document.createElement('input');
                    input.className = 'digit-input';
                    input.value = d.char;
                    input.maxLength = 1;
                    if (d.editable) {
                        input.oninput = (e) => {
                            this.setDigit(i, (e.target as HTMLInputElement).value);
                            let next = input.parentElement!.nextElementSibling;
                            while (next && (!next.classList.contains('digit-input') || (next as HTMLInputElement).disabled)) {
                                next = next.nextElementSibling;
                            }
                            if (next) (next as HTMLElement).focus();
                        };
                        input.onfocus = () => input.select();
                    } else {
                        input.disabled = true;
                        input.classList.add('separator');
                    }
                    grid.appendChild(input);

                    const down = document.createElement('div');
                    down.className = 'digit-btn';
                    if (d.editable && d.char >= '0' && d.char <= '9') {
                        down.textContent = '▼';
                        down.onclick = () => this.changeDigit(i, -1);
                    }
                    grid.appendChild(down);
                });
                lbl.appendChild(grid);
            }

            this.shadow.innerHTML = '';
            this.shadow.appendChild(styleElem);
            this.shadow.appendChild(wrapper);
        }

        get value() { return this.decimalValue; }
        set value(val) {
            this.decimalValue = parseFloat(val as any);
            this.setAttribute('value', this.decimalValue.toString());
            this.render();
        }
    }
    customElements.define('coord-input', CoordInputComponent);
    (window as any).CoordInputComponent = customElements.get('coord-input');
} else {
    (window as any).CoordInputComponent = customElements.get('coord-input');
}


export function initPspPlanner(
    map: L.Map,
    initialPlanString?: Record<string, string>,
    onPlanChange?: (searchPattern: Record<string, string>) => void
) {
    console.log("Initializing PSP Planner...");

    const panelContainerId = 'psp-planner-panel';
    let isLoading = false;

    // --- Inject CSS ---
    const style = document.createElement('style');
    style.innerHTML = `
        #${panelContainerId} { font-family: Arial, sans-serif; color-scheme: light; }
        #${panelContainerId} h3 { font-size: 1.1rem; margin-top: 0; }
        #${panelContainerId} h4 { margin-bottom: 0.5em; }
        #${panelContainerId} section { margin-top: 1rem; padding: 1rem; border: 1px solid #ccc; border-radius: 8px; }
        #${panelContainerId} label { display: flex; align-items: center; gap: 0.5em; }
        #${panelContainerId} .pattern-row label { display: flex; width: auto; }
        #${panelContainerId} input, #${panelContainerId} select { padding: 0.4em; }
        #${panelContainerId} input[type="number"], #${panelContainerId} input[type="text"], #${panelContainerId} select { width: 120px; }
        #${panelContainerId} input[readonly] { background-color: #f0f0f0; color: #555; cursor: not-allowed; }
        #${panelContainerId} table { width: 100%; border-collapse: collapse; margin-top: 1rem; }
        #${panelContainerId} table, #${panelContainerId} th, #${panelContainerId} td { border: 1px solid #ccc; }
        #${panelContainerId} th, #${panelContainerId} td { padding: 0.5rem; text-align: center; }
        #${panelContainerId} .light { color: #aaa; font-size: 0.9em; }
        #${panelContainerId} .hidden { display: none !important; }
        #${panelContainerId} .form-row { display: flex; flex-wrap: wrap; gap: 1em; align-items: center; margin-bottom: 0.8em; }
        #${panelContainerId} .pattern-row { flex-wrap: wrap; }
        #${panelContainerId} .pattern-row label { flex: 1 0 160px; }
        #${panelContainerId} .modal { display: none; position: fixed; z-index: 1001; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.5); }
        #${panelContainerId} .modal-content { background-color: #fff; color: #333; margin: 10% auto; padding: 20px; border-radius: 10px; width: 90%; max-width: 700px; }
        #${panelContainerId} .close-button { float: right; font-size: 20px; cursor: pointer; }

        @media (max-width: 600px) {
            #${panelContainerId} {
                position: fixed !important;
                top: auto !important;
                bottom: 0 !important;
                left: 0 !important;
                width: 100% !important;
                max-width: 100% !important;
                min-width: 0 !important;
                height: 60vh !important;
                max-height: 60vh !important;
                border-radius: 16px 16px 0 0 !important;
                box-shadow: 0 -5px 15px rgba(0,0,0,0.2) !important;
                margin: 0 !important;
                resize: none !important;
                padding: 0.8em !important;
                box-sizing: border-box !important;
            }
            
            #${panelContainerId} label {
                display: flex !important; /* Ensure it's a flex container */
                flex-direction: row !important; /* Explicitly set direction */
                align-items: center !important;
                gap: 0.2em !important;
                /* width: 25% !important; */ /* Removed width constraint */
            }
            
            #${panelContainerId} input[type="number"], 
            #${panelContainerId} input[type="text"], 
            #${panelContainerId} select {
                width: auto !important; /* Let the input size naturally or be constrained by flex-grow */
                flex-grow: 1; /* Allow input to grow */
                box-sizing: border-box !important;
                font-size: 16px !important;
                padding: 0.6em !important;
            }
            
            #${panelContainerId} button {
                padding: 0.7em 1.2em !important;
                min-height: 44px !important;
                font-size: 15px !important;
                border-radius: 6px !important;
            }
            
            #psp-close-btn {
                min-height: 36px !important;
                padding: 0.4em 0.8em !important;
            }
            
            #${panelContainerId} .form-row {
                gap: 0.8em !important;
                margin-bottom: 1em !important;
                flex-direction: row !important; /* Changed to row */
                flex-wrap: wrap !important;
                align-items: center !important; /* Ensure form-row items are aligned */
            }

            #${panelContainerId} .pattern-row {
                flex-direction: row !important;
                flex-wrap: wrap !important;
            }

            #${panelContainerId} .pattern-row label {
                flex: 1 0 120px !important;
            }
            
            #${panelContainerId} table {
                display: block !important;
                width: 100% !important;
                overflow-x: auto !important;
                white-space: nowrap !important;
            }
            
            #${panelContainerId} coord-input {
                display: block !important;
                width: 100% !important;
                margin: 5px 0 !important;
            }

            #${panelContainerId} .modal-content {
                width: 95% !important;
                margin: 5% auto !important;
                padding: 12px !important;
                box-sizing: border-box !important;
            }
            #${panelContainerId} .modal-content section {
                padding: 0.6rem !important;
                margin-top: 0.6rem !important;
            }
            #${panelContainerId} .close-button {
                font-size: 28px !important;
                padding: 6px !important;
            }
        }
    `;
    document.head.appendChild(style);

    // --- Inject HTML ---
    const panelHtml = `
        <div id="${panelContainerId}" class="leaflet-control leaflet-bar" style="display:none; background-color: rgba(255, 255, 255, 0.95); color: #333; padding: 1em; width: auto; max-width: 95%; min-width: 500px; margin: 0; overflow: auto; max-height: 80vh; position: absolute; top: 50px; left: 60px; z-index: 1000; resize: both;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1em; border-bottom: 2px solid #333; padding-bottom: 0.5em;">
                <h3 style="margin: 0; flex-grow: 1; text-align: center; color: #333;">Search Pattern Planner</h3>
                <button id="psp-close-btn">Close</button>
            </div>
            <section id="psp-load-section">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <h4>Saved PSP Patterns</h4>
                    <button type="button" id="save-current-pattern">💾 Save Current Pattern</button>
                </div>
                <div id="psp-pattern-list" style="max-height: 150px; overflow-y: auto;">
                    <!-- Pattern buttons will be populated here -->
                </div>
            </section>
            <section id="section-a">
                <h3>(A) Calculate Drift</h3>
                <button id="open-drift-calc" type="button">Drift Calculator</button>
                <div class="form-box">
                    <div class="form-row"><label>Drift Distance (m): <input type="number" id="drift-dist" /></label></div>
                    <div class="form-row"><label>Drift Time (s): <input type="number" id="drift-time" /></label></div>
                    <div class="form-row"><label>Drift Rate (m/s): <input type="text" id="drift-rate" readonly /></label></div>
                    <div class="form-row"><label>Drift Bearing (True °): <input type="number" id="drift-brg" min="0" max="359"/></label></div>
                    <div class="form-row"><label>Magnetic: <input id="drift-bearing-calc-mag" readonly /></label></div>
                    <div class="form-row"><label>Mag. rounded to 45°: <input id="drift-bearing-calc" readonly /></label></div>
                    <div class="form-row"><label>Last Sight (min): <input type="number" id="last-seen" /></label></div>
                    <div class="form-row"><label>Potential Drift: <input type="text" id="potential-drift" readonly /></label></div>
                </div>
            </section>
            <section id="section-b">
                <h3>(B) Create Search Pattern</h3>
                <button id="open-bsd-calc" type="button">BSD Calculator</button>
                <div class="form-box">
                    <div class="form-row pattern-row">
                        <label><input id="search-type-sector" type="radio" name="pattern" value="sector" />Sector Search</label>
                        <label><input id="search-type-box" type="radio" name="pattern" value="box" />Box Search</label>
                        <label><input id="search-type-creep" type="radio" name="pattern" value="creep" />Creeping Line Ahead</label>
                    </div>
                    <div class="form-row hidden" id="bsd-nm-row"><label>BSD (nM): <input type="number" id="bsd-nautical-miles" data-testid="bsd-input-nm" readonly /></label><label><span id="sw-display-nm" data-testid="sw-display-nm"></span></label></div>
                    <div class="form-row"><label>BSD (m): <input type="number" id="bsd" data-testid="bsd-input-m" /></label><label class="hidden"><span id="sw-display-m" data-testid="sw-display-m"></span></label></div>
                    <div class="form-row"><label>CRV Speed (knots): <input type="number" id="spdk" /></label><label id="spdms-display"></label></div>
                    <div class="form-row"><label id="hdg-label">Initial Heading (°): <input type="number" id="hdg" min="0" max="359" /></label><label class="hidden"><span id="mag-hdg-display" class="sw-display-m"></span></label></div>
                    <div class="form-row"><label>Mag Var (°): <input type="number" id="mag-var" value="20"/></label></div>
                    <div class="form-row"><label>Max Legs: <input type="number" id="max-legs" /></label></div>
                    <div class="form-row"><label id="search-leg-length-label" >Search Leg Dist. (m): <input type="number" id="search-leg-length" /></label></div>
                    <div class="form-row"><label id="search-leg-duration-label" >Search Leg Duration (s): <input type="number" id="search-leg-duration" /></label></div>
                    <div class="hidden" id="cross-leg-controls">
                        <div class="form-row"><label>Cross Leg Dist (m): <input type="number" id="cross-leg-length" /></label></div>
                        <div class="form-row"><label>Duration (s): <input type="number" id="cross-leg-duration" /></label></div>
                        <div class="form-row"><label>First Turn: <select id="cross-leg-turn"><option value="left">Left</option><option value="right" selected>Right</option></select></label></div>
                        <div class="form-row"><label>First Leg Length: <select id="creep-first-leg-length"><option value="half" selected>Half</option><option value="full">Full</option></select></label></div>
                    </div>
                    <table id="results-table" class="hidden">
                        <thead><tr><th>Leg</th><th>°</th><th>Secs</th><th>Metres</th><th colspan="2">Start Time</th><th colspan="2">End Time</th></tr></thead>
                        <tbody id="results-body"></tbody>
                        <tfoot><tr><td colspan="2">Totals</td><td id="total-duration"></td><td id="total-distance"></td><td colspan="4"></td></tr></tfoot>
                    </table>
                </div>
            </section>
            <section id="section-c">
                <h3>(C) Choose Map Position</h3>
                <div class="form-box">
                    <div class="form-row"><button id="psp-toggle-deg-mode-main">Toggle Deg. Mode</button></div>
                    <div class="form-row">
                        <coord-input id="lat-dec" value="0" label="Latitude (n/s)"></coord-input>
                        <coord-input id="lng-dec" value="0" label="Longitude (e/w)"></coord-input>
                    </div>
                    <div class="form-row">
                        <button type="button" id="use-current-location">📍 Use Current Location</button>
                        <button type="button" id="use-locatia-location">📍 Use Sea Map Location</button>
                    </div>
                </div>
            </section>
            <!-- Modals -->
            <div id="drift-calc-modal" class="modal"><div class="modal-content"><span class="close-button" id="close-drift-calc">&times;</span><h4>Calculate Drift</h4><button id="psp-toggle-deg-mode-modal">Toggle Deg. Mode</button><form id="drift-calc-form" class="form-box"><section><h3>Datum In</h3><div class="form-row"><button type="button" id="datum-in-btn">Datum In</button><label>Time: <input type="time" step="1" id="datum-time-in" /></label></div><div class="form-row"><coord-input id="lat-dec-in" value="-36.83333333" label="Lat"></coord-input><coord-input id="lng-dec-in" value="175.0" label="Lng"></coord-input></div></section><section><h3>Datum Out</h3><div class="form-row"><button type="button" id="datum-out-btn">Datum Out</button><label>Time: <input type="time" step="1" id="datum-time-out" /></label></div><div class="form-row"><coord-input id="lat-dec-out" value="-36.83333333" label="Lat"></coord-input><coord-input id="lng-dec-out" value="175.0" label="Lng"></coord-input></div></section><section><h3>Results</h3><div class="form-row"><label>Status: <input type="text" id="modal-datum-status" readonly /></label></div><div class="form-row"><label>Distance (m): <input type="text" id="modal-drift-dist" readonly /></label><label>Time: <input type="text" id="modal-drift-time" readonly /></label><label>Heading (°): <input type="text" id="drift-heading" readonly /></label></div><div class="form-row"><button type="button" id="cancel-drift">Cancel</button><button type="button" id="confirm-drift">OK</button></div></section></form></div></div>
            <div id="bsd-calc-modal" class="modal">
                <div class="modal-content">
                    <span class="close-button" id="close-bsd-calc">×</span>
                    <h4>Calculate BSD</h4>
                    <form id="bsd-calc-form" class="form-box">
                        <section id="uncorrectedvsw">
                            <h3>Base Data</h3>
                        <div class="form-row">
                            <label>Search Object:
                                <select id="object-type">
                                    <option value="">-- Select --</option>
                                    <option value="person" selected="">Person</option>
                                    <option value="raft1">Raft 1 person</option>
                                    <option value="raft4">Raft 4 person</option>
                                    <option value="raft6">Raft 6 person</option>
                                    <option value="raft8">Raft 8 person</option>
                                    <option value="raft10">Raft 10 person</option>
                                    <option value="raft15">Raft 15 person</option>
                                    <option value="raft20">Raft 20 person</option>
                                    <option value="raft25">Raft 25 person</option>
                                    <option value="powerboat0">Power boat up to 4.5 m</option>
                                    <option value="powerboat6">Power boat up to 7.5 m</option>
                                    <option value="powerboat10">Power boat up to 12 m</option>
                                    <option value="powerboat16">Power boat up to 20 m</option>
                                    <option value="powerboat24">Power boat up to 27 m</option>
                                    <option value="sailboat4">Sail Boat up to 4.5 m</option>
                                    <option value="sailboat6">Sail Boat up to 6 m</option>
                                    <option value="sailboat7">Sail Boat up to 7.5 m</option>
                                    <option value="sailboat9">Sail Boat up to 9 m</option>
                                    <option value="sailboat12">Sail Boat up to 12 m</option>
                                    <option value="sailboat15">Sail Boat up to 15 m</option>
                                    <option value="sailboat20">Sail Boat up to 23 m</option>
                                    <option value="sailboat23">Sail Boat up to 27 m</option>
                                </select>
                            </label>
                        </div>
                        <div class="form-row">
                            <label>Height of Eye:
                                <select id="height-eye">
                                    <option value="low">1.8 - 2.4 m</option>
                                    <option value="high">3.6 - 4.2 m</option>
                                </select>
                            </label>
                        </div>
                        <div class="form-row">
                            <label>Visibility (NM):
                                <select id="visibility">
                                    <option value="1">1 NM</option>
                                    <option value="3">3 NM</option>
                                    <option value="5">5 NM</option>
                                    <option value="10">10 NM</option>
                                    <option value="15" selected="">15 NM</option>
                                    <option value="20">20 NM</option>
                                </select>
                            </label>
                        </div>
                        <div class="form-row">
                            <label>Uncorrected VSW (NM): <input type="text" id="display-uncorrected-vsw" readonly /></label>
                        </div>
                        </section>

                        <section id="vswcorrections">
                            <h3>Corrections</h3>
                            <div class="form-row">
                                <label>Wind Speed:
                                    <select id="wind">
                                        <option value="0">Nil</option>
                                        <option value="15" selected="">~ 15 knots, Sea 2-3 ft / 0.5-1.0 m</option>
                                        <option value="25">~ 25 knots, Sea&gt; 4 ft / 1.5 m</option>
                                    </select>
                                </label>
                            </div>
                            <div class="form-row">
                                <label>Target Type Adjustment:
                                    <select id="target-type">
                                        <option value="small" selected="">Small : Person, Vessel lt 30' / 9m, any life raft</option>
                                        <option value="large">Large:  Other targets inc any vessel over 30' / 9m</label>
                                    </select>
                                </label>
                            </div>
                            <div class="form-row">
                                <label>Correction Factor: <input type="text" id="display-correction-factor" readonly /></label>
                            </div>
                        </section>
                        <section>
                            <div class="form-row">
                                <label>Sweep Width (NM): <input type="text" id="display-sweep-width-nm" readonly /></label>
                            </div>
                            <div class="form-row">
                                <label>Beam Sighting Distance (m): <input type="text" id="display-bsd-metres" readonly /></label>
                            </div>
                            <div class="form-row">
                                <button type="button" id="calculate-bsd">Accept</button>
                            </div>
                        </section>
                    </form>
                </div>
            </div>
        </div>
    `;
    
    const appContainer = document.getElementById('app');
    if (appContainer) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = panelHtml;
        while (tempDiv.firstChild) {
            appContainer.appendChild(tempDiv.firstChild);
        }
    } else {
        console.error("App container not found!");
        return;
    }

    // --- Get Element References ---
    const pspPanel = document.getElementById(panelContainerId)!;
    const el = (id: string) => pspPanel.querySelector<HTMLElement>(`#${id}`)!;
    const elInput = (id: string) => pspPanel.querySelector<HTMLInputElement>(`#${id}`)!;
    const elSelect = (id: string) => pspPanel.querySelector<HTMLSelectElement>(`#${id}`)!;

    // --- State Management ---
    const searchData = {
        inputdata: { bsd: '', bsdNauticalMiles: '', creepFirstLegLength: 'half', crossLegLength: '', crossLegDuration: '', crossLegTurn: 'right', datumTimeIn: '', datumTimeOut: '', driftBrg: '', driftDist: '', driftTime: '', hdg: '', magVar: '20', spdk: '', lastSeen: '', latDec: '', latDecIn: '', latDecOut: '', lngDec: '', lngDecIn: '', lngDecOut: '', maxLegs: '', patternName: '', searchType: '', searchLegLength: '', searchLegDuration: '' },
        calculated: { driftModal: { drift: { distance: '' } }, driftBearingCalc: 0, driftRate: 0, potentialDrift: 0, sweepWidth: 0, spdms: 0 },
        legs: [] as any[],
    };

    // Expose searchData for testing
    (window as any).searchData = searchData;

    const toCamelCase = (str: string) => str.replace(/[-_](.)/g, (_, char) => char.toUpperCase());
    const toKebabCase = (str: string) => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/[_\s]+/g, '-').toLowerCase();
    const isValidNonZeroNumber = (value: any) => { const num = Number(value); return !isNaN(num) && isFinite(num) && num !== 0; };
    
    // Hydrate searchData from DOM defaults
    Object.keys(searchData.inputdata).forEach(key => {
        const domId = toKebabCase(key);
        const elem = pspPanel.querySelector<HTMLInputElement | any>(`#${domId}`);
        if (elem && elem.value !== undefined && elem.value !== '' && (searchData.inputdata as any)[key] === '') {
             (searchData.inputdata as any)[key] = elem.value.toString();
        }
    });

    function updateStateAndUrl() {
        if (onPlanChange) {
            onPlanChange(searchData.inputdata);
        }
    }

    function setInputAndState(id: string, value: string | number) {
        const valStr = value.toString();
        const elem = elInput(id);
        if (elem) elem.value = valStr;
        (searchData.inputdata as any)[toCamelCase(id)] = valStr;
        updateStateAndUrl();
    }

    // --- Core Logic ---
    const GEOLOCATION_OPTIONS = { enableHighAccuracy: true, maximumAge: 0, timeout: 30000 };
    const geolocate = () => new Promise<{lat: number, lng: number}>((resolve, reject) => navigator.geolocation.getCurrentPosition(pos => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }), reject, GEOLOCATION_OPTIONS));
    const getTimeStr = () => new Date().toTimeString().slice(0, 8);
    const parseTime = (str: string) => { const [h, m, s] = str.split(':').map(Number); return h * 3600 + m * 60 + s; };
    const formatTime = (seconds: number) => { const h = Math.floor(seconds / 3600); const m = Math.floor((seconds % 3600) / 60); const s = Math.floor(seconds % 60); return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`; };

    function calculateLegTableData() {
        const selectedPattern = searchData.inputdata.searchType;
        if (!selectedPattern || !searchData.calculated.sweepWidth || !searchData.calculated.spdms) return;

        const maxLegs = parseInt(searchData.inputdata.maxLegs, 10);
        if (isNaN(maxLegs) || maxLegs <= 0) return;

        const hdg = parseInt(searchData.inputdata.hdg, 10);
        if (isNaN(hdg)) return;

        const searchLegLength = parseInt(searchData.inputdata.searchLegLength, 10);
        if (isNaN(searchLegLength) || searchLegLength <= 0) {
            if (selectedPattern !== 'creep') return;
        }

        const crossLegLength = parseInt(searchData.inputdata.crossLegLength, 10);
        if (selectedPattern === 'creep' && (isNaN(crossLegLength) || crossLegLength <= 0)) return;

        searchData.legs = [];
        let currentHeading = hdg;
        let elapsedTime = 0;
        const crossLegAdjust = searchData.inputdata.crossLegTurn === 'left' ? 0 : 180;
        const creepFirstLegLength = searchData.inputdata.creepFirstLegLength;

        for (let legnum = 0; legnum < maxLegs; legnum++) {
            const leg = calculateEachLeg(legnum, currentHeading, elapsedTime, selectedPattern, searchLegLength, crossLegAdjust, crossLegLength, creepFirstLegLength);
            elapsedTime += leg.duration;
            currentHeading = leg.bearing;
            searchData.legs.push(leg);
        }
        displayLegs();
    }

    function calculateEachLeg(legnum: number, heading: number, elapsedTime: number, pattern: string, sdpd: number, crossLegAdjust: number, crossLegLength: number, creepFirstLegLength: string) {
        let duration = 0, distance = 0, newHeading = heading;
        const spdms = searchData.calculated.spdms;

        if (pattern === 'sector') {
            newHeading += legnum % 3 === 0 ? 0 : 120;
            if ((legnum > 0) && (legnum % 9 === 0)) newHeading += 30;
            distance = sdpd;
            duration = sdpd / spdms;
        } else if (pattern === 'box') {
            distance = (Math.trunc(legnum / 2) * sdpd) + sdpd;
            duration = distance / spdms;
            newHeading += legnum === 0 ? 0 : 90;
        } else if (pattern === 'creep') {
            if (legnum % 4 === 0) {
                newHeading = heading + 90 + crossLegAdjust;
               distance = legnum === 0 && creepFirstLegLength === 'half' ? sdpd / 2 : sdpd;
            } else if (legnum % 4 === 1) {
                newHeading = heading - 90 + crossLegAdjust;
                distance = crossLegLength;
            } else if (legnum % 4 === 2) {
                newHeading = heading - 90 + crossLegAdjust;
                distance = sdpd;
            } else { // legnum % 4 === 3
                newHeading = heading + 90 + crossLegAdjust;
                distance = crossLegLength;
            }
            duration = distance / spdms;
        }
        newHeading = (newHeading + 360) % 360;
        duration = Math.floor(duration);
        const endTime = elapsedTime + duration;
        return { legnum: legnum + 1, bearing: newHeading, duration, distance, startTime: elapsedTime, endTime };
    }

    function displayLegs() {
        const resultsBody = el('results-body') as HTMLTableSectionElement;
        resultsBody.innerHTML = '';
        let totalDuration = 0, totalDistance = 0;
        searchData.legs.forEach(leg => {
            const row = resultsBody.insertRow();
            row.innerHTML = `<td id="searchleg-${leg.legnum}">${leg.legnum}</td><td id="searchleg-${leg.legnum}-bearing">${leg.bearing}</td><td id="searchleg-${leg.legnum}-duration">${leg.duration}</td><td id="searchleg-${leg.legnum}-distance">${leg.distance.toFixed(0)}</td><td>${leg.startTime}</td><td>${formatTime(leg.startTime)}</td><td>${leg.endTime}</td><td>${formatTime(leg.endTime)}</td>`;
            totalDuration += leg.duration;
            totalDistance += leg.distance;
        });
        el('total-duration').textContent = totalDuration.toString();
        el('total-distance').textContent = totalDistance.toFixed(0);
        el('results-table').classList.remove('hidden');

        if (isValidNonZeroNumber(searchData.inputdata.latDec) || isValidNonZeroNumber(searchData.inputdata.lngDec)) {
            visualizeSearchPattern(map, searchData.inputdata);
        }
    }

    function updateInputField(event: Event) {
        const target = event.target as HTMLInputElement;
        const key = toCamelCase(target.id) as keyof typeof searchData.inputdata;
        if (target.type === 'radio') {
            if (target.checked) (searchData.inputdata as any).searchType = target.value;
        } else {
            (searchData.inputdata as any)[key] = target.value;
        }
        updateStateAndUrl();
    }
    
    function renderSavedPspPatterns() {
        const listContainer = el('psp-pattern-list')!;
        const pspLoadSection = el('psp-load-section')!;
        listContainer.innerHTML = '';
        const savedPatterns = listLocalStorageItems<any>('psp');

        pspLoadSection.style.display = 'block';
        savedPatterns.forEach((item: StoredItem<any>) => {
            const div = document.createElement('div');
            div.style.cssText = 'margin-bottom:0.5em; padding:0.5em; border:1px solid #eee; display:flex; align-items:center; justify-content:space-between;';
            const timestamp = new Date(item.timestamp).toLocaleString();
            
            const infoSpan = document.createElement('span');
            infoSpan.innerHTML = `<strong>${item.name}</strong><br><small>${timestamp}</small>`;
            
            const btnContainer = document.createElement('div');
            const loadBtn = document.createElement('button');
            loadBtn.textContent = '✅ Load';
            loadBtn.style.marginRight = '0.5em';
            loadBtn.onclick = () => {
                isLoading = true;
                Object.assign(searchData.inputdata, item.data);
                for (const [key, value] of Object.entries(searchData.inputdata)) {
                    if (key === 'patternName' || key === 'searchType') {
                        if (key === 'searchType' && value) {
                            const radio = pspPanel.querySelector<HTMLInputElement>(`input[name="pattern"][value="${value}"]`);
                            if (radio) {
                                radio.checked = true;
                            }
                        }
                        continue;
                    }
                    const id = toKebabCase(key);
                    const elem = el(id) as any;
                    if (elem) {
                        elem.value = value as string;
                        elem.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
                handleBsdChange();
                speedInKnotsChanged();
                handlePatternChange();
                updateMagneticHeading();
                calculateLegTableData();
                visualizeSearchPattern(map, searchData.inputdata);
                isLoading = false;
                updateStateAndUrl();
            };

            const deleteBtn = document.createElement('button');
            deleteBtn.textContent = '❌';
            deleteBtn.onclick = () => {
                if (confirm(`Are you sure you want to delete "${item.name}"?`)) {
                    deleteFromLocalStorage('psp', item.name);
                    renderSavedPspPatterns();
                }
            };

            btnContainer.appendChild(loadBtn);
            btnContainer.appendChild(deleteBtn);
            div.appendChild(infoSpan);
            div.appendChild(btnContainer);
            listContainer.appendChild(div);
        });
    }

    function updateDriftRate() {
        const driftDist = parseFloat(elInput('drift-dist').value);
        const driftTime = parseFloat(elInput('drift-time').value);
        if (driftDist && driftTime && driftTime > 0) {
            searchData.calculated.driftRate = driftDist / driftTime;
            elInput('drift-rate').value = `${searchData.calculated.driftRate.toFixed(2)} m/s, ${(searchData.calculated.driftRate / 0.514444).toFixed(2)} kt`;
        } else {
            elInput('drift-rate').value = '';
        }
        updatePotentialDrift();
    }

    function updatePotentialDrift() {
        const lastSightingMinutes = parseFloat(elInput('last-seen').value);
        if (lastSightingMinutes && searchData.calculated.driftRate) {
            const drift = (searchData.calculated.driftRate * lastSightingMinutes * 60);
            searchData.calculated.potentialDrift = drift;
            elInput('potential-drift').value = `${drift.toFixed(0)} m, ${(drift / 1852).toFixed(2)} M`;
        } else {
            elInput('potential-drift').value = '';
        }
    }

    function updateDriftBearing() {
        const driftBrg = parseFloat(elInput('drift-brg').value);
        const magVar = parseFloat(elInput('mag-var').value);
        if (!isNaN(driftBrg) && !isNaN(magVar)) {
            const magBearing = (driftBrg - magVar + 360) % 360;
            elInput('drift-bearing-calc-mag').value = magBearing.toFixed(0);
            const rounded = (Math.round(magBearing / 45) * 45) % 360;
            elInput('drift-bearing-calc').value = rounded.toString();
        }
    }
    
    function speedInKnotsChanged() {
        const spdk = parseFloat(elInput('spdk').value);
        if (spdk) {
            searchData.calculated.spdms = spdk / 2; // Approximate conversion
            el('spdms-display').innerHTML = `~${searchData.calculated.spdms.toFixed(2)} m/s`;
        } else {
            el('spdms-display').textContent = '';
            searchData.calculated.spdms = 0;
        }
        calculateSearchLegDuration();
        calculateCrossLegDuration();
    }

    function calculateSearchLegDuration() {
        if (!searchData.calculated.spdms) return;
        const searchLegLength = parseInt(elInput('search-leg-length').value, 10);
        if (isNaN(searchLegLength)) return;
        const duration = searchLegLength / searchData.calculated.spdms;
        const val = isNaN(duration) ? '0' : Math.round(duration).toString();
        setInputAndState('search-leg-duration', val);
    }

    function calculateSearchLegLength() {
        if (!searchData.calculated.spdms) return;
        const searchLegDuration = parseInt(elInput('search-leg-duration').value, 10);
        if (isNaN(searchLegDuration)) return;
        const length = searchData.calculated.spdms * searchLegDuration;
        const val = isNaN(length) ? '0' : Math.round(length).toString();
        setInputAndState('search-leg-length', val);
    }
    
    function calculateCrossLegDuration() {
        if (!searchData.calculated.spdms) return;
        const crossLegLength = parseInt(elInput('cross-leg-length').value, 10);
        if (isNaN(crossLegLength)) return;
        const duration = crossLegLength / searchData.calculated.spdms;
        const val = isNaN(duration) ? '0' : Math.round(duration).toString();
        setInputAndState('cross-leg-duration', val);
    }

    function calculateCrossLegLength() {
        if (!searchData.calculated.spdms) return;
        const crossLegDuration = parseInt(elInput('cross-leg-duration').value, 10);
        if (isNaN(crossLegDuration)) return;
        const length = searchData.calculated.spdms * crossLegDuration;
        const val = isNaN(length) ? '0' : Math.round(length).toString();
        setInputAndState('cross-leg-length', val);
    }

    function handleBsdChange() {
        const bsdM = parseFloat(elInput('bsd').value);
        const sweepWidthDisplayM = el('sw-display-m');
        if (bsdM) {
            searchData.calculated.sweepWidth = 2 * bsdM;
            sweepWidthDisplayM.textContent = `Sweep Width: ${searchData.calculated.sweepWidth.toFixed(0)} m`;
            sweepWidthDisplayM.parentElement!.classList.remove('hidden');
        } else {
            sweepWidthDisplayM.textContent = '';
            searchData.calculated.sweepWidth = 0;
            sweepWidthDisplayM.parentElement!.classList.add('hidden');
        }
        initialiseLegLengths();
        calculateLegTableData();
    }

    function handlePatternChange() {
        const selectedPattern = (pspPanel.querySelector('input[name="pattern"]:checked') as HTMLInputElement)?.value;
        if (selectedPattern) {
            el('cross-leg-controls').classList.toggle('hidden', selectedPattern !== 'creep');
            updateMaxLegsDefault(selectedPattern);
            initialiseLegLengths();
            calculateLegTableData();
            // Update heading label based on search type
            const hdgLabel = el('hdg-label');
            const hdgInput = el('hdg') as HTMLInputElement;
            const newText = selectedPattern === 'creep' ? 'Search Direction (°): ' : 'Initial Heading (°): ';
            hdgLabel.innerHTML = newText;
            hdgLabel.appendChild(hdgInput);
        }
    }

    function updateMagneticHeading() {
        const hdgInput = elInput('hdg');
        const magVarInput = elInput('mag-var');
        const magHdgDisplay = el('mag-hdg-display');
        
        if (hdgInput.value && magVarInput.value) {
            const hdg = parseFloat(hdgInput.value);
            const magVar = parseFloat(magVarInput.value);
            const magHdg = (hdg + magVar) % 360;
            magHdgDisplay.textContent = `Mag (°): ${magHdg.toFixed(0)}`;
            magHdgDisplay.parentElement!.classList.remove('hidden');
        } else {
            magHdgDisplay.textContent = '';
            magHdgDisplay.parentElement!.classList.add('hidden');
        }
    }

    function initialiseLegLengths() {
        if (isLoading) return;
        const selectedPattern = searchData.inputdata.searchType;
        const sweepWidth = searchData.calculated.sweepWidth;
        const spdms = searchData.calculated.spdms;

        if (!selectedPattern || !sweepWidth) {
            return;
        }

        let searchLegLength = 0;
        let duration = 0;

        if (selectedPattern === 'sector') {
            searchLegLength = sweepWidth * 3;
            setInputAndState('search-leg-length', searchLegLength);
            if (spdms) {
                duration = Math.round(searchLegLength / spdms);
                setInputAndState('search-leg-duration', duration);
            }
        } else if (selectedPattern === 'box') {
            searchLegLength = sweepWidth;
            setInputAndState('search-leg-length', searchLegLength);
            if (spdms) {
                duration = Math.round(searchLegLength / spdms);
                setInputAndState('search-leg-duration', duration);
            }
        } else if (selectedPattern === 'creep') {
            setInputAndState('cross-leg-length', sweepWidth);
            if (spdms) {
                setInputAndState('cross-leg-duration', Math.round(sweepWidth / spdms));
            }
            // Do NOT reset main search leg length/duration for creep
        }
    }

    function updateMaxLegsDefault(pattern: string) {
        const maxLegsInput = elInput('max-legs');
        let legs = 0;
        if (pattern === 'creep') legs = 21;
        else if (pattern === 'sector') legs = 9;
        else if (pattern === 'box') legs = 20;
        maxLegsInput.value = legs.toString();
        maxLegsInput.dispatchEvent(new Event('input'));
    }

    // --- Event Handlers ---
    pspPanel.querySelectorAll('input, select').forEach(elem => elem.addEventListener('input', updateInputField));
    pspPanel.querySelectorAll('coord-input').forEach(elem => elem.addEventListener('input', updateInputField));
    
    el('psp-close-btn').addEventListener('click', () => togglePspPlanner(false));
    el('psp-toggle-deg-mode-main').addEventListener('click', () => (window as any).CoordInputComponent.toggleMode());
    el('psp-toggle-deg-mode-modal').addEventListener('click', () => (window as any).CoordInputComponent.toggleMode());

    el('open-drift-calc').addEventListener('click', () => { el('drift-calc-modal').style.display = 'block'; });
    el('close-drift-calc').addEventListener('click', () => { el('drift-calc-modal').style.display = 'none'; });
    el('cancel-drift').addEventListener('click', () => { el('drift-calc-modal').style.display = 'none'; });

    el('datum-in-btn').addEventListener('click', async () => {
        try {
            const pos = await geolocate();
            const latInEl = el('lat-dec-in') as any;
            const lngInEl = el('lng-dec-in') as any;
            latInEl.value = pos.lat;
            lngInEl.value = pos.lng;
            elInput('datum-time-in').value = getTimeStr();
            latInEl.dispatchEvent(new Event('input', { bubbles: true }));
            lngInEl.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (err: any) { alert(err.message); }
    });

    el('datum-out-btn').addEventListener('click', async () => {
        try {
            const pos = await geolocate();
            const latOutEl = el('lat-dec-out') as any;
            const lngOutEl = el('lng-dec-out') as any;
            latOutEl.value = pos.lat;
            lngOutEl.value = pos.lng;
            elInput('datum-time-out').value = getTimeStr();
            calculateDriftFromModal();
            latOutEl.dispatchEvent(new Event('input', { bubbles: true }));
            lngOutEl.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (err: any) { alert(err.message); }
    });

    function calculateDriftFromModal() {
        const latIn = (el('lat-dec-in') as any).value;
        const lngIn = (el('lng-dec-in') as any).value;
        const latOut = (el('lat-dec-out') as any).value;
        const lngOut = (el('lng-dec-out') as any).value;
        const timeIn = parseTime(elInput('datum-time-in').value);
        const timeOut = parseTime(elInput('datum-time-out').value);

        if (latIn && lngIn && latOut && lngOut && !isNaN(timeIn) && !isNaN(timeOut)) {
            const p1 = L.latLng(latIn, lngIn);
            const p2 = L.latLng(latOut, lngOut);
            const dist = p1.distanceTo(p2);
            const time = Math.abs(timeOut - timeIn);
            const heading = (bearing([p1.lng, p1.lat], [p2.lng, p2.lat]) + 360) % 360;

            elInput('modal-drift-dist').value = dist.toFixed(0);
            elInput('modal-drift-time').value = time.toString();
            elInput('drift-heading').value = heading.toFixed(0);
            elInput('modal-datum-status').value = "Calculated";
        }
    }

    el('lat-dec-in').addEventListener('input', calculateDriftFromModal);
    el('lng-dec-in').addEventListener('input', calculateDriftFromModal);
    el('datum-time-in').addEventListener('input', calculateDriftFromModal);
    el('lat-dec-out').addEventListener('input', calculateDriftFromModal);
    el('lng-dec-out').addEventListener('input', calculateDriftFromModal);
    el('datum-time-out').addEventListener('input', calculateDriftFromModal);

    el('confirm-drift').addEventListener('click', () => {
        elInput('drift-dist').value = elInput('modal-drift-dist').value;
        elInput('drift-time').value = elInput('modal-drift-time').value;
        elInput('drift-brg').value = elInput('drift-heading').value;
        
        elInput('drift-dist').dispatchEvent(new Event('input'));
        elInput('drift-time').dispatchEvent(new Event('input'));
        elInput('drift-brg').dispatchEvent(new Event('input'));
        
        el('drift-calc-modal').style.display = 'none';
    });

    function updateBsdDisplayFields() {
        const objectType = elSelect('object-type').value;
        const heightEye = elSelect('height-eye').value;
        const visibility = parseFloat(elSelect('visibility').value);
        const wind = elSelect('wind').value;
        const targetType = elSelect('target-type').value;
        
        if (!objectType || isNaN(visibility)) {
            el('display-uncorrected-vsw').value = '';
            el('display-correction-factor').value = '';
            el('display-sweep-width-nm').value = '';
            el('display-bsd-metres').value = '';
            return;
        }
        
        const uncorrected = (bsdData.uncorrectedSweepWidths as any)[objectType]?.[heightEye]?.[visibility];
        const correction = (bsdData.corrections.target as any)[targetType]?.wind?.[wind];
        
        if (uncorrected === undefined || correction === undefined) {
            el('display-uncorrected-vsw').value = '';
            el('display-correction-factor').value = '';
            el('display-sweep-width-nm').value = '';
            el('display-bsd-metres').value = '';
            return;
        }
        
        el('display-uncorrected-vsw').value = uncorrected.toFixed(2);
        el('display-correction-factor').value = correction.toFixed(2);
        
        const correctedVsw = Math.max(uncorrected * correction, 0);
        const correctedVswMetres = Math.max(correctedVsw * 1852, 0);
        const bsdVsw = correctedVsw / 2;
        const bsdMetres = correctedVswMetres / 2;
        
        el('display-sweep-width-nm').value = correctedVsw.toFixed(2);
        el('display-bsd-metres').value = bsdMetres.toFixed(0);
    }
    
    el('open-bsd-calc').addEventListener('click', () => {
        updateBsdDisplayFields();
        el('bsd-calc-modal').style.display = 'block';
    });
    el('close-bsd-calc').addEventListener('click', () => { el('bsd-calc-modal').style.display = 'none'; });

    el('calculate-bsd').addEventListener('click', () => {
        const objectType = elSelect('object-type').value;
        const heightEye = elSelect('height-eye').value;
        const visibility = parseFloat(elSelect('visibility').value);
        const wind = elSelect('wind').value;
        const targetType = elSelect('target-type').value;
        
        const uncorrected = (bsdData.uncorrectedSweepWidths as any)[objectType][heightEye][visibility];
        const correction = (bsdData.corrections.target as any)[targetType].wind[wind];
        const correctedVsw = Math.max(uncorrected * correction, 0);
        const correctedVswMetres = Math.max(correctedVsw * 1852, 0);
        
        elInput('bsd').value = (correctedVswMetres / 2).toFixed(0);
        elInput('bsd-nautical-miles').value = (correctedVsw / 2).toFixed(2);
        el('bsd-nautical-miles').dispatchEvent(new Event('input'));
        
        el('sw-display-nm').textContent = `Sweep Width: ${(correctedVsw).toFixed(2)} nM`;
        el('bsd-nm-row').classList.remove('hidden');

        el('bsd').dispatchEvent(new Event('input'));
        el('bsd-calc-modal').style.display = 'none';
    });

    el('object-type').addEventListener('change', updateBsdDisplayFields);
    el('height-eye').addEventListener('change', updateBsdDisplayFields);
    el('visibility').addEventListener('change', updateBsdDisplayFields);
    el('wind').addEventListener('change', updateBsdDisplayFields);
    el('target-type').addEventListener('change', updateBsdDisplayFields);

    el('drift-dist').addEventListener('input', updateDriftRate);
    el('drift-dist').addEventListener('input', updateInputField);
    el('drift-dist').addEventListener('input', calculateLegTableData);

    el('drift-time').addEventListener('input', updateDriftRate);
    el('drift-time').addEventListener('input', updateInputField);
    el('drift-time').addEventListener('input', calculateLegTableData);

    el('last-seen').addEventListener('input', updatePotentialDrift);
    el('last-seen').addEventListener('input', updateInputField);
    el('last-seen').addEventListener('input', calculateLegTableData);

    el('drift-brg').addEventListener('input', updateDriftBearing);
    el('drift-brg').addEventListener('input', updateInputField);
    el('drift-brg').addEventListener('input', calculateLegTableData);

    el('mag-var').addEventListener('input', updateDriftBearing);
    el('mag-var').addEventListener('input', calculateLegTableData);

    el('spdk').addEventListener('input', speedInKnotsChanged);
    el('spdk').addEventListener('input', calculateLegTableData);
    
    el('bsd').addEventListener('input', handleBsdChange);
    el('bsd').addEventListener('input', updateInputField);
    el('bsd').addEventListener('input', () => {
        const bsdVal = parseFloat(elInput('bsd').value);
        if (!isNaN(bsdVal)) {
            const bsdNm = bsdVal / 1852;
            elInput('bsd-nautical-miles').value = bsdNm.toFixed(2);
            el('sw-display-nm').textContent = `Sweep Width: ${(bsdNm * 2).toFixed(2)} nM`;
            el('bsd-nm-row').classList.remove('hidden');
            el('bsd-nautical-miles').dispatchEvent(new Event('input'));
        } else {
            elInput('bsd-nautical-miles').value = '';
            el('sw-display-nm').textContent = '';
            el('bsd-nm-row').classList.add('hidden');
            el('bsd-nautical-miles').dispatchEvent(new Event('input'));
        }
    });

    el('search-leg-duration').addEventListener('input', calculateSearchLegLength);
    el('search-leg-duration').addEventListener('input', calculateLegTableData);
    el('search-leg-length').addEventListener('input', calculateSearchLegDuration);
    el('search-leg-length').addEventListener('input', calculateLegTableData);
    el('cross-leg-duration').addEventListener('input', calculateCrossLegLength);
    el('cross-leg-duration').addEventListener('input', calculateLegTableData);
    el('cross-leg-length').addEventListener('input', calculateCrossLegDuration);
    el('cross-leg-length').addEventListener('input', calculateLegTableData);
    el('cross-leg-turn').addEventListener('input', calculateLegTableData);
    el('creep-first-leg-length').addEventListener('input', calculateLegTableData);
    el('hdg').addEventListener('input', calculateLegTableData);
    el('hdg').addEventListener('input', updateMagneticHeading);
    el('mag-var').addEventListener('input', updateMagneticHeading);
    el('max-legs').addEventListener('input', calculateLegTableData);

    pspPanel.querySelectorAll('input[name="pattern"]').forEach(radio => radio.addEventListener('change', handlePatternChange));

    el('save-current-pattern').addEventListener('click', () => {
        const currentPatternName = searchData.inputdata.patternName || '';
        const patternName = prompt("Enter a name for this search pattern:", currentPatternName);
        if (!patternName) {
            return;
        }
        
        searchData.inputdata.patternName = patternName;
        const dataToSave = JSON.parse(JSON.stringify(searchData.inputdata));
        saveToLocalStorage('psp', patternName, dataToSave);
        updateStateAndUrl();
        renderSavedPspPatterns();
    });

    el('use-current-location').addEventListener('click', async (e) => {
        const btn = e.target as HTMLButtonElement;
        const originalText = btn.innerText;
        btn.innerText = '⏱ Awaiting GPS...';
        try {
            const pos = await geolocate();
            (el('lat-dec') as any).value = pos.lat;
            (el('lng-dec') as any).value = pos.lng;
            el('lat-dec').dispatchEvent(new Event('input'));
            el('lng-dec').dispatchEvent(new Event('input'));
            calculateLegTableData();
        } catch (err: any) {
            alert(`Failed to get location: ${err.message}`);
        } finally {
            btn.innerText = originalText;
        }
    });

    el('use-locatia-location').addEventListener('click', () => {
        const saved = localStorage.getItem("locatia");
        if (saved) {
            try {
                const { lat, lng } = JSON.parse(saved);
                (el('lat-dec') as any).value = lat;
                (el('lng-dec') as any).value = lng;
                el('lat-dec').dispatchEvent(new Event('input'));
                el('lng-dec').dispatchEvent(new Event('input'));
                calculateLegTableData();
            } catch { /* ignore */ }
        }
    });

    // --- Panel Visibility ---
    function togglePspPlanner(clearPattern = false) {
        const isVisible = pspPanel.style.display === 'block';
        pspPanel.style.display = isVisible ? 'none' : 'block';
        if (isVisible && clearPattern) {
            clearSearchPatterns(map);
        } else if (!isVisible) {
            map.getContainer().dispatchEvent(new CustomEvent('close-other-panels', { detail: panelContainerId }));
            renderSavedPspPatterns();
            if (searchData.legs.length > 0) {
                visualizeSearchPattern(map, searchData.inputdata);
            }
        }
    }

    map.getContainer().addEventListener('open-psp-planner-panel', () => {
        togglePspPlanner(false);
    });

    map.getContainer().addEventListener('close-other-panels', (e: any) => {
        if (e.detail !== panelContainerId && pspPanel.style.display === 'block') {
            togglePspPlanner(true);
        }
    });

    // --- Initial Load ---
    if (initialPlanString) {
        Object.assign(searchData.inputdata, initialPlanString);
        for (const [key, value] of Object.entries(searchData.inputdata)) {
            if (key === 'patternName' || key === 'searchType') {
                if (key === 'searchType' && value) {
                    const radio = pspPanel.querySelector<HTMLInputElement>(`input[name="pattern"][value="${value}"]`);
                    if (radio) {
                        radio.checked = true;
                    }
                }
                continue;
            }
            const elem = el(toKebabCase(key)) as any;
            if (elem) {
                if (elem.tagName === 'COORD-INPUT') {
                    elem.value = value;
                } else if (elem.type === 'radio') {
                    if (elem.value === value) elem.checked = true;
                } else {
                    elem.value = value as string;
                }
                elem.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        handleBsdChange();
        speedInKnotsChanged();
        handlePatternChange();
        calculateLegTableData();
        visualizeSearchPattern(map, searchData.inputdata);
        updateStateAndUrl();
    }
    renderSavedPspPatterns(); // Initial render
}